var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPistachio = function SvgPistachio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pistachio_svg__a)",
    d: "M195.787 148.758s4.98-11.794 0-22.139S89.22 123.38 89.22 123.38L80 134.88 110.135 165l82.664-9.136z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pistachio_svg__b)",
    d: "M90.246 140.373a.756.756 0 0 1 .429-1.4c17.721.665 121.474 3.433 115.038-23.158-7.035-29.067-101.511-38.088-121.612-18.042s-20.1 26.98-20.1 33.536 9.046 19.586 10.051 24.6 13.065 28.065 53.268 27.062 80.009-23.447 69.348-34.078c-3.015-3.007 9.046 9.021-55.278 4.009-31.815-2.482-46.19-9.442-51.144-12.529"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pistachio_svg__a",
    x1: 93.57,
    x2: 196.395,
    y1: 143.616,
    y2: 130.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pistachio_svg__b",
    x1: 74.651,
    x2: 183.063,
    y1: 149.786,
    y2: 81.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgPistachio;